import React, { useContext, useEffect, useState } from "react";
import {
    useReactTable,
    getCoreRowModel,
    flexRender,
} from "@tanstack/react-table";

import {
    fetchsampoornatableDataMoreTime,
    fetchtataalerttabledetails,
    fetchttatakavachTableDetails,
    fetchZippyTableDetail,
} from "./apiInsights";

import { FilterContext } from "../../context/Filter";
import Tataalerttable from "./Tataalerttable";
import Tatakavach from "./Tatakavchtable";
import Tatazippy from "./Tablezippy";

const Moretimetable = () => {
    const { superArn: parArn, childArn } = useContext(FilterContext);

    // dynamic ARN key
    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;

    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState([]);
    const [zippyData, setZippyData] = useState([]);
    const [kavachData, setKavachData] = useState([]);
    const [loading, setLoading] = useState(false);

    // -------------------------------------------------------------
    // MAIN TABLE API
    // -------------------------------------------------------------
    const getMoretime = async () => {
        try {
            setLoading(true);
            const payload = { [key]: value };
            const res = await fetchsampoornatableDataMoreTime(payload);

            setData(res?.tata_more_time_total || []);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    // -------------------------------------------------------------
    // TATA ALERT API
    // -------------------------------------------------------------
    const handleTataAlert = async (year) => {
        const payload = { [key]: value, yearsData: year };
        const res = await fetchtataalerttabledetails(payload);

        const rows =
            res?.data?.alert_reachtime ||
            res?.alert_reachtime ||
            [];

        // console.log("Tata Alert rows:", rows);

        setAlertData(rows);
        setZippyData([]);
        setKavachData([]);
    };


    const handleTataZippy = async (year) => {
        const payload = { [key]: value, yearsData: year };
        const res = await fetchZippyTableDetail(payload);
        // console.log("zippydata", res)

        const rows = res?.data?.data || [];   // <-- FIXED

        setZippyData(rows);
        setAlertData([]);
        setKavachData([]);
    };


    const handleTataKavach = async (year) => {
        const payload = { [key]: value, yearsData: year };
        const res = await fetchttatakavachTableDetails(payload);

        const rows = res?.data?.data || [];   // <-- FIXED
        // console.log("Kavach rows:", rows);

        setKavachData(rows);
        setAlertData([]);
        setZippyData([]);
    };

    useEffect(() => {
        getMoretime();
    }, []);


    const yearColumn = (keyName) => ({
        accessorKey: keyName,
        header: keyName,
        cell: ({ row }) => {
            const program = row.original.program;
            const value = row.getValue(keyName);
            const year = keyName;

            return (
                <span
                    className="cursor-pointer text-blue-600 hover:underline"
                    onClick={() => {
                        if (program === "Tata Alert") handleTataAlert(year);
                        if (program === "Tata Zippy") handleTataZippy(year);
                        if (program === "Tata Kavach") handleTataKavach(year);
                    }}
                >
                    {value}
                </span>
            );
        },
    });

    const columns = [
        { accessorKey: "sr_no", header: "Sr No" },
        { accessorKey: "program", header: "Program" },
        yearColumn("2019-20"),
        yearColumn("2020-21"),
        yearColumn("2021-22"),
        { accessorKey: "ALL", header: "# Of Vehicles" },
    ];

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    // -------------------------------------------------------------
    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-4">Sampoorna More Time Data</h2>

            <div className="overflow-x-auto border rounded-lg">
                {loading ? (
                    <div className="p-6 text-center">Loading...</div>
                ) : (
                    <table className="min-w-full text-sm border-collapse">
                        <thead className="bg-gray-100">
                            {table.getHeaderGroups().map((hg) => (
                                <tr key={hg.id}>
                                    {hg.headers.map((header) => (
                                        <th key={header.id} className="border px-4 py-2 font-medium text-left">
                                            {header.column.columnDef.header}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>

                        <tbody>
                            {table.getRowModel().rows.map((row) => (
                                <tr key={row.id} className="even:bg-gray-50">
                                    {row.getVisibleCells().map((cell) => (
                                        <td key={cell.id} className="border px-4 py-2">
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>

            {/* ---------------- PROGRAM DETAILS TABLE ---------------- */}

            {alertData.length > 0 && (
                <div className="mt-6">
                    <h3 className="text-lg font-semibold mb-2 text-[#267CB8]">Tata Alert Details</h3>
                    <Tataalerttable data={alertData} />
                </div>
            )}

            {zippyData.length > 0 && (
                <div className="mt-6">
                    <h3 className="text-lg font-semibold mb-2 text-[#267CB8]">Tata Zippy Details</h3>
                    <Tatazippy data={zippyData} />
                </div>
            )}

            {kavachData.length > 0 && (
                <div className="mt-6">
                    <h3 className="text-lg font-semibold mb-2 text-[#267CB8]">Tata Kavach Details</h3>
                    <Tatakavach />
                </div>
            )}
        </div>
    );
};

export default Moretimetable;
